var _path, _path2, _path3, _line, _line2, _line3, _line4, _line5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    id: "Email",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff894c",
    stroke: "#5f4436",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M3,25.67v30a4,4,0,0,0,4,4H57a4,4,0,0,0,4-4v-30Z",
    className: "colorec6d5e svgShape colorStroke5f363a svgStroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#cfb4a6",
    stroke: "#5f4436",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M3,25.51,29.73,43.94a4,4,0,0,0,4.54,0L61,25.51h0c-17.27-10.24-40.73-10.24-58,0Z",
    className: "colora6c0cf svgShape colorStroke5f363a svgStroke"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff5f0",
    stroke: "#5f4436",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M14.5,33.44V7.3a3,3,0,0,1,3-3h29a3,3,0,0,1,3,3V33.43L34.27,43.94a4,4,0,0,1-4.54,0L14.51,33.44",
    className: "colorfffaf0 svgShape colorStroke5f363a svgStroke"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 41.5,
    x2: 22.5,
    y1: 13.19,
    y2: 13.19,
    fill: "none",
    stroke: "#5f4436",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    className: "colorStroke5f363a svgStroke"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 32,
    x2: 22.5,
    y1: 28.6,
    y2: 28.6,
    fill: "none",
    stroke: "#5f4436",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    className: "colorStroke5f363a svgStroke"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 41.5,
    x2: 22.5,
    y1: 20.9,
    y2: 20.9,
    fill: "none",
    stroke: "#5f4436",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    className: "colorStroke5f363a svgStroke"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 25.18,
    x2: 4.29,
    y1: 40.82,
    y2: 58.62,
    fill: "none",
    stroke: "#5f4436",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    className: "colorStroke5f363a svgStroke"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 38.77,
    x2: 59.72,
    y1: 40.82,
    y2: 58.62,
    fill: "none",
    stroke: "#5f4436",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    className: "colorStroke5f363a svgStroke"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.777baa5e58b62e5343783bd73e42e6f4.svg";
export { ForwardRef as ReactComponent };